var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-favorite-heart-icon"},[_c('i',_vm._b({staticClass:"fa-heart vuw-text-second-1",class:_vm.heartIconType},'i',_vm.$attrs,false)),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }